import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { useHistory, useLocation } from "react-router-dom";
import "./whats_new.css";

const STEPS = [
  { key: "composer", icon: "✍️", to: "/post/new_post" },
  { key: "inbox", icon: "💬", to: "/inbox" },
  { key: "library", icon: "🖼️", to: "/library" },
  { key: "analytics", icon: "📈", to: "/analytics" },
  { key: "manage", icon: "🧭", to: "/lists" },
];

const WhatsNew = ({ userId }) => {
  const { t } = useTranslation("whats_new");
  const history = useHistory();
  const location = useLocation();
  const storageKey = "spk_tour_v2_" + userId;
  const forced = new URLSearchParams(location.search).get("tour") === "1";
  const [open, setOpen] = useState(() => forced || !localStorage.getItem(storageKey));
  const [step, setStep] = useState(-1);

  if (!open || !userId) return null;

  const close = () => {
    localStorage.setItem(storageKey, "1");
    setOpen(false);
  };
  const s = STEPS[step];
  const last = step === STEPS.length - 1;

  return (
    <div className="wn_overlay" role="dialog" aria-modal="true">
      <div className="wn_modal">
        <button type="button" className="wn_skip" onClick={close}>{t("skip")}</button>
        {!s ? (
          <div className="wn_body">
            <span className="wn_badge">{t("badge")}</span>
            <h2>{t("welcome_title")}</h2>
            <p>{t("welcome_text")}</p>
          </div>
        ) : (
          <div className="wn_body">
            <div className="wn_icon">{s.icon}</div>
            <h2>{t(s.key + "_title")}</h2>
            <p>{t(s.key + "_text")}</p>
            <button type="button" className="wn_link" onClick={() => { close(); history.push(s.to); }}>{t("try_it")} →</button>
          </div>
        )}
        <div className="wn_footer">
          <div className="wn_dots">
            {[-1, ...STEPS.map((_, i) => i)].map((i) => <span key={i} className={i === step ? "on" : ""} />)}
          </div>
          <div className="wn_nav">
            {step >= 0 && <button type="button" className="wn_btn wn_ghost" onClick={() => setStep(step - 1)}>{t("back")}</button>}
            <button type="button" className="wn_btn wn_primary" onClick={() => (last ? close() : setStep(step + 1))}>
              {last ? t("done") : step === -1 ? t("start") : t("next")}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default WhatsNew;
